<section class="main-page">
  <app-header />

  <app-scroll-projects />

  <app-mobile-menu />
</section>
